/**
 *  When I select the country as United States of America and catalog as Tri-State Research
 *  Then I should see a new group in Groups dropdown called “Edit Address”
 *  Else hide “Edit Address”
 */
import { Pipe, PipeTransform } from '@angular/core';
import { UserGroups } from '@shared/models/iuser.model';

const EDIT_ADDRESS_GROUP_KEY = 17;
const TRI_STATE_RESEARCH_LOB_KEY = 104;

export const FilterUserGroups = (userGroupOptions: UserGroups[], userLobSkey: number): UserGroups[] => {
  // Get all groups except Edit Address if not Tri-State Research
  let userGroupOptionsFiltered = userGroupOptions || [];
  if (userLobSkey !== TRI_STATE_RESEARCH_LOB_KEY) {
    userGroupOptionsFiltered = (userGroupOptions || []).filter(group => group.key !== EDIT_ADDRESS_GROUP_KEY);
  }
  // Sort alphabetically by value
  return userGroupOptionsFiltered.sort((a, b) => a.value?.localeCompare(b.value ?? '') || 0);
};

@Pipe({
  name: 'filterUserGroups',
  standalone: false,
})
export class FilterUserGroupsPipe implements PipeTransform {
  transform(userGroupOptions: UserGroups[], userLobSkey: number): any {
    return FilterUserGroups(userGroupOptions, userLobSkey);
  }
}
